import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AssessmentPage from "./pages/AssessmentPage";
import CustomizePage from "./pages/CustomizePage";
import CustomizeGuidePage from "./pages/CustomizeGuidePage";
import CoachingPage from "./pages/CoachingPage";
import PremiumPage from "./pages/PremiumPage";
import PremiumSuccessPage from "./pages/PremiumSuccessPage";
import AdminPremiumPage from "./pages/AdminPremiumPage";
import AdminCoachingToolsPage from "./pages/AdminCoachingToolsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import MakeAdminPage from "./pages/MakeAdminPage";
import ProgressDashboard from "./pages/ProgressDashboard";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import { Toaster } from "./components/ui/toaster";
import { authAPI } from "./services/api";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadUser = async () => {
      const savedUser = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      
      if (savedUser && token) {
        // Try to refresh user data from backend
        try {
          const freshUser = await authAPI.getMe();
          localStorage.setItem('user', JSON.stringify(freshUser));
          setUser(freshUser);
        } catch (error) {
          // If API fails, use cached user
          setUser(JSON.parse(savedUser));
        }
      }
    };
    
    loadUser();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar user={user} onLogout={handleLogout} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/customize" element={<CustomizePage />} />
          <Route path="/customize-guide" element={<CustomizeGuidePage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/progress" element={<ProgressDashboard />} />
          <Route path="/premium" element={<PremiumPage />} />
          <Route path="/premium/success" element={<PremiumSuccessPage />} />
          <Route path="/admin-premium" element={<AdminPremiumPage />} />
          <Route path="/admin-coaching-tools" element={<AdminCoachingToolsPage />} />
          <Route path="/admin-users" element={<AdminUsersPage />} />
          <Route path="/make-admin" element={<MakeAdminPage />} />
          <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
          <Route path="/signup" element={<SignupPage onLogin={handleLogin} />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
